// AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Estados iniciales
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    // Bootstrap auth
    const initSession = () => {
      const storedIsAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
      const jwtToken = localStorage.getItem('JWT');

      if (storedIsAuthenticated && jwtToken) {
        // La sesión está persistida temporalmente
        setAuthenticated(true);
      } else {
        // No hay sesión persistida
        setAuthenticated(false);
      }
      setIsInitializing(false);
    };

    initSession();
  }, []);
  const logInContext = () => {

    // Lógica de autenticación, puede ser una llamada a una API o manejo de tokens
    setAuthenticated(true);
    // Guardar el estado de autenticación en localStorage
    localStorage.setItem('isAuthenticated', 'true');
  };


  const logOutContext = () => {
    // Lógica de cierre de sesión, como limpiar tokens o redirigir a la página de inicio de sesión
    setAuthenticated(false);
    // Eliminar el estado de autenticación de localStorage
    localStorage.removeItem('isAuthenticated');
  };


  return (
    <AuthContext.Provider value={{ isAuthenticated, isInitializing, logInContext, logOutContext }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
